import { render, staticRenderFns } from "./MessageCondensed.vue?vue&type=template&id=a73ab39e&"
import script from "./MessageCondensed.vue?vue&type=script&lang=js&"
export * from "./MessageCondensed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports